export const dimensions = [{
    name: 'Tonalitás',
    icon: 'lg-smiling',
    description: 'Használj pozitívabb kontextust. Vagy növeld a pozitív vagy negatív kifejezések számát az erőteljesebb érzelmek érdekében. A pozitív kifejezéseket tedd hátrébb a szövegben, míg a nem túl pozitív kifejezéseket és tedd előrébb a szövegben.'
  }, {
    name: 'Tömörség',
    icon: 'lg-length-limit',
    description: 'Növeld a szöveg hosszát, ugyanakkor csökkentsd a szavak számát, hogy jobb legyen a dimenzió. Használj több töltelékkifejezést, hogy ne legyen túl tömör a szöveg.'
  }, {
    name: 'Írásjelek',
    icon: 'lg-advise',
    description: 'Alkalmazz kérdést vagy felkiáltójelet. De ne túl sokat. A %-jelet próbáld kerülni.'
  }, {
    name: 'Fogalmazás',
    icon: 'lg-ghost',
    description: 'Használj kevesebb meglepetéssel kapcsolatos szót és használj Fomo jellegű kifejezéset. Cselekvésre felszólítás vagy akcióra utaló szót is segíthet.'
  }, {
    name: 'Konkrétumok',
    icon: 'lg-apple',
    description: 'Növeld a márkák, tulajdonnevek vagy fontos témák számát. A márkát tedd előrébb a szövegben. Használj helyet és tedd hátrébb a szövegben, valamint tedd hátrébb a fő témákat.'
  }
]

export function labelFor(id) {
  return dimensions[id].name
}

export function descriptionFor(id) {
  return dimensions[id].description
}